import React from "react";
import style from "./ContentCard.module.css";
import Button from "@material-ui/core/Button";
import { NavLink as RouterLink } from "react-router-dom";
import { Link } from "@material-ui/core/";

export const ContentCard = ({ imagen, title, text, action }) => {
  return (
    <div className={style.container}>
      <img src={imagen} alt="img" className={style.img} />
      <div className={style.txtCont}>
        <h3 className={style.title}>{title}</h3>
        <p className={style.text}>{text}</p>
      </div>
      <div className={style.btnCont}>
        <Link className={style.link}>
          <Button
            className={style.btn}
            variant="contained"
            color="primary"
            onClick={action}
          >
            Leer mas
          </Button>
        </Link>
      </div>
    </div>
  );
};
